$(document).ready(function () {
$(window).on("scroll", function () {
  if ($(".mobile-dock-section .mobile-dock").hasClass("dock-active")) {
    $("body").addClass("remove_header_icons");
  } else {
    $("body").removeClass("remove_header_icons");
  }
});
// $(".cstm_display-none .cstm-checkout.cstm-data.atc__button.button.btn-block").click(function(){
//   $('.dynamic-checkout-button ').find('button.shopify-payment-button__more-options.BUz42FHpSPncCPJ4Pr_f').trigger('click');
// });
});
function divFunction(){
  $('.dynamic-checkout-button .shopify-payment-button').find('#more-payment-options-link').trigger('click');
}


